// Generated by Melange

import * as Buhta_cabinet__Input from "../../html/Input.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Cn from "../../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function TableSearchRow(Props) {
  let className = Props.className;
  let onSearchOpt = Props.onSearch;
  let childrenOpt = Props.children;
  const onSearch = onSearchOpt !== undefined ? onSearchOpt : (function (param) {
      
    });
  const children = childrenOpt !== undefined ? Caml_option.valFromOption(childrenOpt) : null;
  const match = React.useState(function () {
    return "";
  });
  const setSearchText = match[1];
  const handleSearch = function (value) {
    Curry._1(setSearchText, (function (param) {
      return value;
    }));
    Curry._1(onSearch, value);
  };
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("img", {
            alt: "icon",
            src: StaticAsset.src("/static/icons/search.svg")
          }),
          JsxRuntime.jsx(Buhta_cabinet__Input.make, {
            value: match[0],
            placeholder: "Поиск...",
            type_: "text",
            onChange: handleSearch
          })
        ],
        className: "grow grid grid-cols-auto-1 gap-x-1 items-center"
      }),
      JsxRuntime.jsx("div", {
        children: children,
        className: "flex items-center space-x-4"
      })
    ],
    className: Cn.fromList({
      hd: "flex items-center border-b border-gray-main py-4 px-6 h-14",
      tl: {
        hd: Cn.take(className),
        tl: /* [] */ 0
      }
    })
  });
}

const make = TableSearchRow;

export {
  make,
}
/* Buhta_cabinet__Input Not a pure module */
